var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewVisaCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 17,
    viewBox: "0 0 25 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8569 -9.15527e-05H1.38527C0.620206 -9.15527e-05 0 0.620939 0 1.38702V15.2581C0 16.0242 0.620206 16.6452 1.38527 16.6452H22.8569C23.622 16.6452 24.2422 16.0242 24.2422 15.2581V1.38702C24.2422 0.620939 23.622 -9.15527e-05 22.8569 -9.15527e-05Z",
    fill: "#EBF3FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3707 11.1543H9L9.85749 5.84587H11.2282L10.3707 11.1543Z",
    fill: "#00579F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3423 5.97596C15.0718 5.86846 14.6431 5.74986 14.1129 5.74986C12.7591 5.74986 11.8061 6.47255 11.8002 7.50594C11.7887 8.26851 12.4824 8.69193 13.0015 8.94612C13.5317 9.20585 13.7118 9.37543 13.7118 9.60708C13.7066 9.96253 13.2834 10.1265 12.889 10.1265C12.3415 10.1265 12.0485 10.0419 11.6028 9.84427L11.4223 9.75931L11.2305 10.9508C11.5519 11.0975 12.1441 11.2276 12.7591 11.2335C14.1974 11.2335 15.1338 10.5219 15.1449 9.4205C15.1504 8.81642 14.784 8.35347 13.9944 7.97513C13.5148 7.73204 13.2211 7.56837 13.2211 7.31973C13.227 7.09398 13.4694 6.86233 14.0107 6.86233C14.4564 6.85123 14.7837 6.95839 15.0316 7.06589L15.1556 7.12206L15.3423 5.97596Z",
    fill: "#00579F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1596 9.27377C17.2725 8.96861 17.7067 7.78852 17.7067 7.78852C17.7012 7.79996 17.8196 7.4778 17.8872 7.28014L17.9831 7.73754C17.9831 7.73754 18.2425 9.00814 18.2989 9.27377C18.0846 9.27377 17.4304 9.27377 17.1596 9.27377ZM18.8517 5.84587H17.7912C17.4643 5.84587 17.216 5.94192 17.075 6.28627L15.0391 11.154H16.4773C16.4773 11.154 16.7138 10.4989 16.7648 10.3578C16.9227 10.3578 18.3218 10.3578 18.5247 10.3578C18.5642 10.5444 18.6882 11.154 18.6882 11.154H19.9574L18.8517 5.84587Z",
    fill: "#00579F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85688 5.84587L6.51454 9.46553L6.3677 8.7314C6.11973 7.88457 5.34122 6.96423 4.47266 6.50648L5.70244 11.1484H7.15177L9.30621 5.84587H7.85688Z",
    fill: "#00579F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.26725 5.84587H3.06191L3.03906 5.95337C4.75957 6.39378 5.89893 7.45561 6.3668 8.73175L5.88751 6.29217C5.80855 5.95302 5.56612 5.85731 5.26725 5.84587Z",
    fill: "#FAA61A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewVisaCard);
export default __webpack_public_path__ + "static/media/NewVisaCard.5acc8fc3.svg";
export { ForwardRef as ReactComponent };